import { render, staticRenderFns } from "./ModalReturnCargo.vue?vue&type=template&id=168018ea&scoped=true&"
import script from "./ModalReturnCargo.vue?vue&type=script&lang=js&"
export * from "./ModalReturnCargo.vue?vue&type=script&lang=js&"
import style0 from "./ModalReturnCargo.vue?vue&type=style&index=0&id=168018ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168018ea",
  null
  
)

export default component.exports